export const amspaudaLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/amspauda.svg"

export const bioanalizesLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/bioanalizessistemoslogo.svg"

export const biomatterLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/biomatterlogo.svg"

export const dspLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/dsplogo.svg"

export const emailLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/emaillogo.svg"

export const fbLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/fblogo.svg"

export const gitlabLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/gitlablogo.svg"

export const igemLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/igemlogo.svg"

export const igLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/iglogo.svg"

export const laboramaLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/laboramalogo.svg"

export const lineliberaLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/linealiberalogo.svg"

export const medicinaPracticaLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/medicinapracticalogo.svg"

export const progemLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/progemlogo.svg"

export const thermoLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/thermologo.svg"

export const vortoGamaLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/vortogamalogo.svg"

export const vuLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/vulogo.svg"

export const websiteLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/websitelogo.svg"

export const gmcLogo =
  "https://static.igem.wiki/teams/4380/wiki/footer/gmclogo.svg"
